{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "Percuma {amount} hari",
    "{amount} off": "",
    "{amount} off for first {number} months.": "{amount} potongan untuk {number} bulan pertama.",
    "{amount} off for first {period}.": "{amount} potongan untuk {period} pertama.",
    "{amount} off forever.": "{amount} potongan selama-lamanya.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% diskaun",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} tidak akan menerima newsletter {newsletterName} lagi.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} tidak akan menerima email apabila seseorang membalas komen anda.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} tidak akan menerima newsletter ini lagi.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "Percuma {trialDays} hari",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Akaun",
    "Account details updated successfully": "",
    "Account settings": "Tetapan akaun",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Selepas tempoh percubaan percuma tamat, anda akan dicaj harga biasa untuk peringkat yang anda pilih. Anda sentiasa boleh membatalkan sebelum itu.",
    "Already a member?": "Sudah menjadi ahli?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Ralat yang tidak dijangka berlaku. Sila cuba lagi atau <a>hubungi sokongan</a> jika ralat berterusan.",
    "Back": "Kembali",
    "Back to Log in": "Kembali ke Log masuk",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Batalkan bila-bila masa.",
    "Cancel subscription": "Batalkan langganan",
    "Canceled": "",
    "Cancellation reason": "Alasan pembatalan",
    "Change": "Ubah",
    "Change plan": "",
    "Check spam & promotions folders": "Semak folder spam & promosi",
    "Check with your mail provider": "Semak dengan pembekal mel anda",
    "Check your inbox to verify email update": "",
    "Choose": "Pilih",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Pilih pelan yang berbeza",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Pilih newsletter anda",
    "Click here to retry": "Klik di sini untuk cuba semula",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Tutup",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Komen",
    "Complimentary": "",
    "Confirm": "Sahkan",
    "Confirm cancellation": "Sahkan pembatalan",
    "Confirm subscription": "Sahkan langganan",
    "Contact support": "Hubungi sokongan",
    "Continue": "Teruskan",
    "Continue subscription": "Teruskan langganan",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Tidak dapat log masuk. Pautan log masuk tamat tempoh.",
    "Could not update email! Invalid link.": "Tidak dapat mengemas kini e-mel! Pautan tidak sah.",
    "Create a new contact": "Cipta kenalan baru",
    "Current plan": "Pelam semasa",
    "Delete account": "Padam akaun",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Tidak bermaksud untuk melakukan ini? Urus pilihan anda <butang>di sini</button>.",
    "Don't have an account?": "Tiada akaun?",
    "Edit": "Sunting",
    "Email": "E-mel",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Newsletter e-mel",
    "Email newsletter settings updated": "",
    "Email preferences": "Emel pilihan",
    "Email preferences updated.": "",
    "Emails": "E-mel",
    "Emails disabled": "E-mel dilumpuhkan",
    "Ends {offerEndDate}": "Tamat pada {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Ralat",
    "Expires {expiryDate}": "Luput pada {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Selamanya",
    "Free Trial – Ends {trialEnd}": "Percubaan Percuma – Tamat {trialEnd}",
    "From": "",
    "Get help": "Dapatkan bantuan",
    "Get in touch for help": "Hubungi untuk mendapatkan bantuan",
    "Get notified when someone replies to your comment": "Dapatkan pemberitahuan apabila seseorang membalas komen anda",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Berikan maklum balas mengenai pos ini",
    "Help! I'm not receiving emails": "Tolong! Saya tidak menerima e-mel",
    "Here are a few other sites you may enjoy.": "",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Jika newsletter ditanda sebagai spam, e-mel akan dilumpuhkan secara automatik untuk alamat tersebut untuk memastikan anda tidak lagi menerima sebarang mesej yang tidak diingini.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Jika aduan spam itu tidak disengajakan, atau anda ingin mula menerima e-mel semula, anda boleh melanggan semula e-mel dengan mengklik butang pada skrin sebelumnya.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Jika anda membatalkan langganan anda sekarang, anda akan terus mendapat akses sehingga {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Jika anda mempunyai akaun e-mel korporat atau kerajaan, hubungi jabatan IT anda dan minta mereka membenarkan e-mel diterima daripada {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Pautan log masuk telah dihantar ke peti masuk anda. Jika ia tidak sampai dalam masa 3 minit, pastikan anda menyemak folder spam anda.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Jika anda ingin mula menerima e-mel semula, langkah terbaik seterusnya ialah menyemak alamat e-mel anda pada fail untuk sebarang isu dan kemudian klik langgan semula pada skrin sebelumnya.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Jika anda tidak menerima newsletter e-mel yang anda langgan, berikut adalah beberapa perkara untuk diperiksa.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Jika anda telah menyelesaikan semua semakan ini dan anda masih tidak menerima e-mel, anda boleh menghubungi untuk mendapatkan sokongan dengan menghubungi {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Sekiranya kegagalan kekal diterima semasa cuba menghantar newsletter, e-mel akan dilumpuhkan pada akaun.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Dalam klien e-mel anda tambah {senderEmail} pada senarai kenalan anda. Ini memberi isyarat kepada pembekal mel anda bahawa e-mel yang dihantar dari alamat ini harus dipercayai.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Kurang macam ni",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Pastikan e-mel tidak tiba-tiba masuk ke dalam folder Spam atau Promosi peti masuk anda. Jika ya, klik pada \"Tandakan sebagai bukan spam\" dan/atau \"Alih ke peti masuk\".",
    "Manage": "Urus",
    "Maybe later": "",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "",
    "month": "",
    "Monthly": "Bulanan",
    "More like this": "Lebih seperti ini",
    "More options": "",
    "Name": "Nama",
    "Need more help? Contact support": "Perlukan bantuan lagi? Hubungi sokongan",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Newsletter boleh dilumpuhkan pada akaun anda atas dua sebab: E-mel sebelumnya telah ditandakan sebagai spam atau percubaan menghantar e-mel mengakibatkan kegagalan kekal (bounce).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Tidak menerima e-mel?",
    "Now": "",
    "Now check your email!": "Semak e-mel anda sekarang!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Setelah melanggan semula, jika anda masih tidak melihat e-mel dalam peti masuk anda, semak folder spam anda. Sesetengah pembekal peti masuk menyimpan rekod aduan spam sebelumnya dan akan terus membenderakan e-mel. Jika ini berlaku, tandakan surat berita terkini sebagai 'Bukan spam' untuk mengalihkannya kembali ke peti masuk utama anda.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Kegagalan kekal (bounce)",
    "Phone number": "",
    "Plan": "Pelan",
    "Plan checkout was cancelled.": "Daftar keluar pelan telah dibatalkan.",
    "Plan upgrade was cancelled.": "Naik taraf pelan telah dibatalkan.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Sila isikan medan yang diperlukan",
    "Podcasts": "",
    "Re-enable emails": "Membolehkan semula e-mel",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Perbaharui pada {price}.",
    "Resume subscription": "",
    "Retry": "Cuba semula",
    "Save": "Simpan",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Menghantar pautan log masuk...",
    "Sending...": "Menghantar...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "",
    "Sign in": "Log masuk",
    "Sign out": "Log keluar",
    "Sign up": "Daftar",
    "Signup error: Invalid link": "Ralat daftar: Pautan tidak sah",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Maaf, itu tidak berfungsi.",
    "Spam complaints": "Aduan spam",
    "Start {amount}-day free trial": "Mulakan percubaan percuma {amount} hari",
    "Starting {startDate}": "Mulai {startDate}",
    "Starting today": "Mulai hari ini",
    "Submit feedback": "Serahkan maklum balas",
    "Subscribe": "Langgan",
    "Subscribed": "Dilanggan",
    "Subscription plan updated successfully": "",
    "Success": "Berjaya",
    "Success! Check your email for magic link to sign-in.": "Berjaya! Semak e-mel anda untuk magic link untuk log masuk.",
    "Success! Your account is fully activated, you now have access to all content.": "Berjaya! Akaun anda telah diaktifkan sepenuhnya, anda kini mempunyai akses ke semua kandungan.",
    "Success! Your email is updated.": "Berjaya! E-mel anda dikemas kini.",
    "Successfully unsubscribed": "Pemberhentian langganan berjaya",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Terima kasih atas maklum balas!",
    "That didn't go to plan": "Itu tidak berjalan sesuai dengan rancangan",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Alamat e-mel yang kami miliki untuk anda adalah {memberEmail} — jika itu tidak betul, anda boleh mengemas kini di <button>ruang tetapan akaun</button> anda.",
    "There was a problem submitting your feedback. Please try again a little later.": "Terdapat masalah menghantar maklum balas anda. Sila cuba sebentar lagi.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Laman web ini hanya untuk jemputan, hubungi pemilik untuk akses.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Untuk melengkapkan pendaftaran, klik pautan pengesahan di peti masuk anda. Jika ia tidak tiba dalam masa 3 minit, semak folder spam anda!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Cuba secara percuma selama {amount} hari, kemudian {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Buka akses ke semua newsletter dengan menjadi pelanggan berbayar.",
    "Unsubscribe from all emails": "Berhenti langganan dari semua e-mel",
    "Unsubscribed": "Langganan diberhentikan",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Memberhentikan langganan dari e-mel tidak akan membatalkan langganan berbayar anda ke {title}",
    "Update": "Kemas kini",
    "Update your preferences": "Kemas kini keutamaan anda",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "Sahkan jika alamat e-mel anda betul",
    "Verifying...": "",
    "View plans": "Lihat pelan",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Kami tidak dapat membatalkan langganan anda kerana alamat e-mel tidak ditemui. Sila hubungi pemilik laman web.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Selamat kembali, {name}!",
    "Welcome back!": "Selamat kembali!",
    "Welcome to {siteTitle}": "",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Apabila peti masuk gagal menerima e-mel, ia biasanya disebut sebagai bounce. Dalam banyak kes, ini hanya sementara. Walau bagaimanapun, dalam beberapa kes, e-mel bounce boleh dikembalikan sebagai kegagalan kekal apabila alamat e-mel tidak sah atau tidak wujud.",
    "Why has my email been disabled?": "Mengapa e-mel saya telah dilumpuhkan?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Tahunan",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Anda kini mempunyai keahlian percuma, naik taraf ke langganan berbayar untuk akses penuh.",
    "You have been successfully resubscribed": "Anda telah berjaya melanggan semula",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Anda kini tidak menerima e-mel",
    "You're not receiving emails": "Anda tidak menerima e-mel",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Anda tidak menerima e-mel kerana anda sama ada menandai mesej terkini sebagai spam, atau kerana mesej tidak dapat dihantar ke alamat e-mel yang diberikan.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Anda telah berjaya log masuk.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "",
    "Your account": "Akaun anda",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Input anda membantu membentuk apa yang diterbitkan.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Langganan anda akan tamat tempoh pada {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Langganan anda akan diperbaharui pada {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Langganan anda akan bermula pada {subscriptionStart}"
}
